import DashboardLastMagazinesList from "./DashboardLastMagazinesList";

export default DashboardLastMagazinesList;